export async function loadCashfreeSdk() {
  if (window.Cashfree) return;
  await new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Could not load Cashfree checkout"));
    document.head.appendChild(s);
  });
}

export async function launchCashfree(data) {
  const session = data?.payment_session_id;
  if (!session) {
    if (data?.checkout_url) {
      window.location.assign(data.checkout_url);
      return;
    }
    throw new Error("Cashfree session missing. Try checkout again.");
  }
  await loadCashfreeSdk();
  const cashfree = window.Cashfree({ mode: data.mode === "production" ? "production" : "sandbox" });
  const result = await cashfree.checkout({ paymentSessionId: session, redirectTarget: "_self" });
  if (result?.error) {
    throw new Error(result.error.message || "Cashfree could not open checkout.");
  }
}

export async function launchCashfreeMandate(data) {
  const session = data?.subscription_session_id;
  if (!session) throw new Error("Cashfree mandate session missing. Try again.");
  await loadCashfreeSdk();
  const cashfree = window.Cashfree({ mode: data.mode === "production" ? "production" : "sandbox" });
  await cashfree.subscriptionsCheckout({ subsSessionId: session, redirectTarget: "_self" });
}
